<template>
  <v-app
    id="home"
    class="prevent-browser-printing"
  >
    <core-toolbar />

    <core-drawer />
    <v-content>
      <div 
        id="core-view" 
        :class="{'mb-0 pb-0': isOnChartPages}"
      >
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>        
      </div>
      
      <core-footer v-if="!isOnChartPages" />

      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        dark
      >
        <v-icon
          color="white"
          class="mr-4"
        >
          mdi-bell-plus
        </v-icon>
        <div> {{ message }}</div>
        <v-icon
          size="16"
          @click="setSnackbar(false)"
        >
          mdi-close-circle
        </v-icon>
      </v-snackbar>

      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="500"
          persistent
        >
          <v-card>
            <v-alert
              :type="dialogColor"
            >
              {{ dialogTitle }}
            </v-alert>

            <v-card-text>
              {{ dialogMessage }}
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                text
                @click="setDialog(false)"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <app-dialog-idle />
    </v-content>
  </v-app>
</template>

<script>
  import {
    mapMutations,
    mapState,
  } from 'vuex'

  export default {
    inject: ['$validator'],
    components: {
      AppDialogIdle: () => import('@/components/AppDialogIdle'),
    },
    metaInfo () {
      return {
        title: 'SELAT HR',
      }
    },
    data () {
      return {
        timerId: '',
      }
    },
    computed: {
      ...mapState('app', ['message', 'snackbarColor', 'top', 'bottom', 'left', 'right', 'dialog', 'dialogTitle', 'dialogMessage', 'dialogColor']),
      snackbar: {
        get () {
          return this.$store.state.app.snackbar
        },
        set (val) {
          this.setSnackbar(val)
        },
      },
      isOnChartPages () {
        return this.$route.name === 'Organization Chart' || this.$route.name === 'KPI Chart'
      },
    },
    beforeDestroy () {
      clearTimeout(this.timerId)
    },
    mounted () {
      this.interceptHttpResponses()
      this.setExpirationInterval()      
    },
    methods: {
      ...mapMutations('app', ['setSnackbar', 'setDialog']),
      interceptHttpResponses () {
        this.$http.interceptors.response.use(undefined, (err) => {
          if ((err.response || {}).status === 401) {
            this.manualLogout()
          } else if (err.response.status === 422) {
            if (err.response.data.errors) {        
              for (let key in err.response.data.errors) {
                this.$validator.errors.add({
                  field: key, 
                  msg: JSON.stringify(err.response.data.errors[key][0]).replace(/"/g, ''),
                })
              }

              this.$scrollToFirstErrorInput()
            }
          } 
          
          if (err.response.status === 403) {
            this.$snack({
              color: 'error',
              message: 'Unauthorized action',
            })
          } 
          
          if (err.response.status === 400) {
            this.$snack({
              color: 'error',
              message: err.response.data.message,
            })
          }

          return Promise.reject(err)
        })
      },
      setExpirationInterval () {      
        let promptInSecs = (this.$store.state.tokenExpiration.getTime() - new Date().getTime()) / 1000

        if (promptInSecs < 0) {
          this.manualLogout()
          return
        }

        if (promptInSecs >= 40) {
          promptInSecs -= 20
        } else {
          promptInSecs = 0
        }

        this.setAccessRefreshTimer(promptInSecs)
      },
      setAccessRefreshTimer (secs) {
        this.timerId = setTimeout(() => {      
          this.refreshAccess()
        }, secs * 1000)
      },
      refreshAccess () {
        this.$refreshAccess()
          .then(() => {
            this.setExpirationInterval()
          })
      },  
      manualLogout () {
        this.$manualLogout()
          .then(() => {
            this.$router.push({ path: '/login' })
          })
      },
    },
  }
</script>

<style lang="scss">
  #core-view {
    padding-bottom: 100px;
  }

  @import '@/styles/index.scss';

  @media print {
  .prevent-browser-printing {
    display: none;
  }
}
</style>
